import { UsersIcon, Plus } from 'lucide-react';

import { Button } from '@/components/ui/button';
import { EmptyBlock } from '@/components/ui/empty-block';

import { useRepresentative } from '../model';

const EmptyRepresentatives = () => {
  const { addRepresentative, currentPolicyRole } = useRepresentative();

  return (
    <EmptyBlock
      description="No representatives added"
      icon={UsersIcon}
      withCard={false}
      action={
        currentPolicyRole?.update && (
          <Button variant="outline" size="sm" onClick={addRepresentative}>
            <Plus /> Add representative
          </Button>
        )
      }
    />
  );
};

export default EmptyRepresentatives;
